import { BaseService, Service } from "/@/cool";
@Service("orderFee")
class OrderFee extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["page"] = prefix + "page";
		this.permission["exportExcel"] = prefix + "exportExcel";
	}
}
export default OrderFee;
